import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { QuartilService } from '../quartil-service/quartil.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';
import { FormatarData } from './../../../../shared/formatarData';
import { Estado } from './../../../../shared/shared/estado.enum';

@Component({
  selector: 'app-quartil-cadastro',
  templateUrl: './quartil-cadastro.component.html'
})
export class QuartilCadastroComponent
extends CrudBase
implements OnInit {

  constructor(
    service: QuartilService,
    toastr: ToastrService,
    ) {
      super(service, toastr);
    }

    dataInicial;

    ngOnInit() {
      this.dataInicial = this.model.data_inicio;
      if (!this.model) {
        this.model = {};
      }
      this.defineModelVazio();
    }

    novo() {
      super.novo();
      this.defineModelVazio();
    }

    private defineModelVazio() {
      if (this.state === Estado.insert) {
        this.model.id = null;
      }
    }

    salvar () {
      if (this.model.data_inicio.day) {
        this.model.data_inicio = new FormatarData(
          this.model.data_inicio.year,
          this.model.data_inicio.month,
          this.model.data_inicio.day,
          0,
          0,
          0
          ).getDataString();
        }
        if (this.model.data_fim.day) {
          this.model.data_fim = new FormatarData(
            this.model.data_fim.year,
            this.model.data_fim.month,
            this.model.data_fim.day,
            0,
            0,
            0
            ).getDataString();
          }
          super.salvar ();
        }
      }
